import priceSelectionList from '../utils/getPriceSelectionList';
import getTotalsForSetOfTotals from '../utils/getTotalsForSetOfTotals';
import { pricingFields } from './mobilityFieldNames';

export const getMobilityTotals = (formFields, orderData) => {
  const customerInformationTotals = getTotalsForSetOfTotals(
    pricingFields,
    formFields,
    orderData
  );
  return customerInformationTotals;
};

export const getMobilityPriceSelections = formFields => {
  const selectionsList = priceSelectionList(pricingFields, formFields);
  return selectionsList;
};
